import { createContext, useContext } from "react";
import {
  unsafe_deepMerge,
  JSONTry,
  Logger,
  textParamsParser,
} from "../helpers";
import { useRootStore } from "src/stores/Root.store";

export const TranslationContext = createContext({});

export const useTranslation = (translationFile: any = {}) => {
  const translationContext = useContext(TranslationContext);
  const genericTranslation = require("src/translations/generic.json");
  const {
    $translationStore: { language$ },
  } = useRootStore();

  // Merges translation object from Context and local translationFile
  const mergedTranslation = unsafe_deepMerge(
    genericTranslation,
    translationContext,
    translationFile
  );
  const developmentEnv = process.env.NODE_ENV === "development";

  return (path: string, params: string[] = []) => {
    const splitByDot = path.split(".");
    const [lastPath] = splitByDot.slice(-1);

    const translated = JSONTry(
      mergedTranslation,
      `${language$}.${path}`,
      developmentEnv ? `missing_translation:${path}` : lastPath
    );

    if (translated === lastPath) {
      Logger.info("Mising translation: " + path);
    }

    return textParamsParser(translated, params);
  };
};
